module.exports = __webpack_public_path__ + "static/media/alice.213ff530.png";